import React from 'react'
import './ImageStyleSheet.css';

function EduOne() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/thsimg1.jpeg" className='img-view'/>
        </div>
    )
}

export default EduOne
